import { CSSProperties } from 'react';
import Image from 'components/Image';
import Button, { ButtonProps, ButtonSize, ButtonVariant, ButtonWidth } from '../Button';

const DEFAULT_IMAGE_STYLE = { height: '20px' };

export default function AffiliateButton({
  image,
  imageStyle,
  children,
  ...props
}: ButtonProps & { image: string; imageStyle?: CSSProperties }) {
  return (
    <Button variant={ButtonVariant.GRAY} width={ButtonWidth.FULL} size={ButtonSize.LARGE} {...props}>
      {children}
      <Image src={image} style={imageStyle ?? DEFAULT_IMAGE_STYLE} />
    </Button>
  );
}
